export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/facebook.e112023e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};